'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./login/login'));
    processInclude(require('./profile/isCompany'));
    require('./checkout/address').init('');
});
